import React, { useState } from 'react';
import '../styles/App.css';
import { Switch, Route } from 'react-router-dom';
import HomePage from './HomePage';
import VideoPlayerPage from './VideoPlayerPage';
import AllVideosPage from './AllVideosPage';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const App = () => {
  const [theme, setTheme] = useState({
    palette: {
      type: 'dark',
    },
  });

  const toggleDarkTheme = () => {
    let newPaletteType = theme.palette.type === 'light' ? 'dark' : 'light';
    setTheme({
      palette: {
        type: newPaletteType,
      },
    });
  };

  const muiTheme = createMuiTheme(theme);

  return (
    <MuiThemeProvider theme={muiTheme}>
      <div className="App">
        <Switch>
          <Route
            exact
            path="/"
            component={() => <HomePage onToggleDark={toggleDarkTheme} />}
          />
          <Route exact path="/video/:id" component={VideoPlayerPage} />
          <Route exact path="/videos" component={AllVideosPage} />
        </Switch>
      </div>
    </MuiThemeProvider>
  );
};

export default App;
